<template>
    <div>
        <sys-select-base 
            :model.sync="selected"
            :items="items"
            :loading="loading"
            :label="label"
            :error="error"
            :errors="errors"
            @onShowForm="showForm = true"
            :clearable="clearable"
            :showAdd="showAdd"
            :dense="dense"
            @change="$emit('change', $event)"
        >

            <template v-if="showDescription" v-slot:dataItem="{ item }">
                <span class="mb-2">
                    {{ item.name }}
                    <small v-if="item.description"><br/> {{ item.description }}</small>
                </span>
            </template>

        </sys-select-base>
        <sys-occurrence-type-register @onCompleted="newItem" :model="{}" v-bind:show.sync="showForm" />
    </div>
</template>

<script>

import { mapActions, mapState } from 'vuex'

export default {
    name: 'SysSelectOccurrenceType',
    data: () => ({
        items: [],
        loading: false,
        selected: null,
        showForm: false
    }),
    computed: {
        ...mapState('auth', ['acesso'])
    },
    mounted(){
        
    },
    created() {
        this.getItems();
    },
    props: {
        
        error: {
            type: Boolean,
            default: false
        },
        errors: {
            type: Array,
        },
        label: {
            type: String,
            required: true
        },
        clearable: {
            type: Boolean,
            default: false
        },
        showAdd: {
            type: Boolean,
            default: false
        },
        dense: {
            type: Boolean,
            default: false
        },
        model: {
        
        },
        filterAdditional: {

        },
        hideHolliday: {
            type: Boolean,
            default: false
        },
        hidePreMarked: {
            type: Boolean,
            default: false
        },
        showDescription: {
            type: Boolean,
            default: false
        },
        isTeacher: {
            type: Boolean,
            default: false
        }
    },
    watch: {
        
        selected(val){
            this.$emit('update:model', val);
        },
        
        model(val){
            this.selected = val;
        },

        filterAdditional(val){
            this.getItems();
        }
    },
    methods: {
        ...mapActions('timeSheet', ['ActionFindOccurrenceTypes', 'ActionFindOccurrenceTypesTeacher']),
        
        async getItems() {

            this.loading = true;

            let payload = {
                find_columns: {
                    active: 1
                }
            };

            if(this.filterAdditional !== null){
                payload.find_columns.is_additional = this.filterAdditional;
            }

            if(this.hideHolliday){
                payload.find_columns.is_holiday = 0;
            }

            if(this.hidePreMarked){
                payload.find_columns.pre_marked = 0;
            }

            const action = this.isTeacher 
                ? this.ActionFindOccurrenceTypesTeacher 
                : this.ActionFindOccurrenceTypes;

            await action(payload)
                    .then((res) => {
                        this.items = res.data;
                        this.selected = this.model;
                    })
                    .catch(() => {
                        // Erro silencioso - tipos de ocorrência não carregados
                    })
                    .finally(() => {
                        this.loading = false;
                    })
        },

    newItem(item){
            
            if(item){
                this.items.push(item);
                this.selected = item.id;
                this.showForm = false;
                this.$emit('new-item', item);
            }
        }
    },

    
    
}
</script>